import React from 'react';

import {
  Button,
  MaterialIcon,
} from '@pearsontechnology/aero-components';

import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import messages from './messages';

const AddProjectContentButton = (props) => (
  <Button primary {...props}>
    <MaterialIcon left id="add" />
    {intl.formatMessage(messages.content)}
  </Button>
);

export default AddProjectContentButton;
